import React, { useState } from "react";

import FilterPopoverPortal from "./FilterPopoverPortal";

interface ColumnFilterPopoverProps {
  columnId: string;
  title: string;
  options: { label: string; value: any; checked: boolean }[];
  onApply: (checkedValues: any[]) => void;
  onClear: () => void;
  onClose: () => void;
}

export const ColumnFilterPopover: React.FunctionComponent<
  ColumnFilterPopoverProps
> = ({ columnId, title, options, onApply, onClear, onClose }) => {
  const [localOptions, setLocalOptions] = useState(options);

  const handleToggle = (index: number) => {
    const next = [...localOptions];
    next[index] = { ...next[index], checked: !next[index].checked };
    setLocalOptions(next);
  };

  const handleSelectAll = () => {
    const next = localOptions.map((opt) => ({ ...opt, checked: true }));
    setLocalOptions(next);
  };

  const handleDeselectAll = () => {
    const next = localOptions.map((opt) => ({ ...opt, checked: false }));
    setLocalOptions(next);
  };

  const handleApply = () => {
    const checkedValues = localOptions
      .filter((opt) => opt.checked)
      .map((opt) => opt.value);
    onApply(checkedValues);
    onClose();
  };

  const handleClear = () => {
    onClear();
    onClose();
  };

  return (
    <FilterPopoverPortal>
      <div className="popover-header">
        <span className="popover-title">{title}</span>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="popover-body">
        {localOptions.length > 5 && (
          <div className="quick-actions">
            <button onClick={handleSelectAll}>全選択</button>
            <button onClick={handleDeselectAll}>全解除</button>
          </div>
        )}
        <div className="options-list">
          {localOptions.length === 0 ? (
            <div className="no-options">No options available</div>
          ) : (
            localOptions.map((opt, index) => (
              <label key={`${columnId}-opt-${index}`} className="option-label">
                <input
                  type="checkbox"
                  checked={opt.checked}
                  onChange={() => handleToggle(index)}
                />
                <span className="checkbox-custom"></span>
                <span className="label-text" title={opt.label}>
                  {opt.label}
                </span>
              </label>
            ))
          )}
        </div>
      </div>
      <div className="popover-footer">
        <button className="clear-btn" onClick={handleClear}>
          クリア
        </button>
        <button className="apply-btn" onClick={handleApply}>
          適用
        </button>
      </div>
    </FilterPopoverPortal>
  );
};
export default ColumnFilterPopover;
